// Prices page component
export function EPCInfoPage() {
    return `
<div class="min-h-screen bg-gray-50">
    <div class="hero">
        <div class="hero-content">
            <h1 class="hero-title">Información</h1>
            <p class="hero-subtitle">Sobre certificados energéticos en España</p>
        </div>
    </div>

    <section class="section bg-gray-50">
        <div class="container">
            <div class="md:flex md:items-start md:space-x-8">

                <main class="md:w-2/3">

                    <div class="max-w-4xl mx-auto prose prose-lg">
                        <div class="bg-white p-8 rounded-lg shadow-sm">

                            <h2 id="why-energy-label" class="text-2xl text-blue-900 mb-4">¿Por qué un certificado energético?</h2>

                            <p class="mb-4">
El certificado energético, tal como lo conocemos hoy, surgió de la creciente preocupación por el cambio climático y la necesidad de reducir el consumo energético de los edificios. Además, el certificado energético en España, al igual que en el resto de la Unión Europea, es legalmente obligatorio al vender, alquilar o construir viviendas y locales comerciales.

<strong>Por qué un certificado energético: el planeta se está calentando</strong><br><br>

La Tierra se calienta debido a la emisión de gases de efecto invernadero, incluida la CO₂, que se liberan entre otros por el consumo energético de los edificios. Los hogares y las empresas desempeñan un papel importante: la calefacción, la refrigeración y el consumo de electricidad representan una parte significativa de las emisiones totales.

El certificado energético se creó para hacer visibles y comparables estas prestaciones energéticas.  
De este modo, propietarios y compradores pueden ver cuán eficiente es un inmueble y se fomenta la adopción de medidas de ahorro energético como:
<br>• mejor aislamiento de muros, tejado y ventanas;<br>
• instalación de paneles solares;<br>
• o la sustitución de sistemas de calefacción por modelos más eficientes, como una bomba de calor.

Gracias a ello, los certificados energéticos contribuyen a los objetivos climáticos europeos y a la reducción de emisiones de CO₂ en el sector de la edificación.

<strong>Por qué un certificado energético: es una obligación legal</strong><br><br>

El certificado energético es obligatorio en España según el Real Decreto 390/2021, que aplica la Directiva Europea 2010/31/UE sobre eficiencia energética de los edificios.

Para vender, alquilar o construir una vivienda o local comercial es necesario disponer de un certificado energético válido.  
Además, el certificado debe aparecer en los anuncios, tanto online (portales inmobiliarios, redes sociales) como offline.

Las comunidades autónomas son responsables de supervisar esta obligación. Quien venda o alquile un inmueble sin certificado puede enfrentarse a multas que varían por región y pueden llegar a varios cientos de euros.

<strong>Excepciones a la obligación</strong><br><br>

En España, al igual que en otros países de la UE, existen algunas excepciones donde no es obligatorio disponer de un certificado energético.  
No se requiere certificado para:
<br>• edificios protegidos por su valor histórico o arquitectónico;<br>
• edificios de uso religioso (iglesias, mezquitas);<br>
• edificios independientes de menos de 50 m²;<br>
• edificios agrícolas o industriales usados únicamente para almacenamiento o procesos;<br>
• edificios temporales con una duración prevista inferior a dos años;<br>
• viviendas de uso vacacional ocupadas menos de 4 meses al año;<br>
• edificios sin consumo energético para calefacción o refrigeración (como garajes o almacenes).

El certificado energético no es solo una obligación legal: es también una herramienta clave para fomentar un uso más eficiente de la energía y una menor huella ambiental.

A través de <strong>CEEcasasespaña.com</strong> puede encontrar rápidamente un técnico certificador que evalúe su vivienda o local según la normativa española.
                            </p>
                        </div>
                    </div>

                    <br>

                    <div class="max-w-4xl mx-auto prose prose-lg">
                        <div class="bg-white p-8 rounded-lg shadow-sm">

<h2 id="what-is-energy-label" class="text-2xl text-blue-900 mb-4">¿Qué es un certificado energético?</h2>

<p class="mb-4">
Para poder comparar de forma clara la eficiencia energética de los edificios, se creó el certificado energético.  
Pero ¿qué información contiene exactamente?

<strong>La clasificación: de la A a la G</strong><br><br>

En el certificado energético aparecen las letras de la A a la G que indican cuán eficiente es una vivienda o local:

<br><strong>A</strong> significa muy eficiente  
<br><strong>G</strong> significa muy poco eficiente

La clasificación se determina en función de varios factores, como:
<br>• aislamiento en muros, tejado, suelos y ventanas;<br>
• tipo de sistemas de calefacción y refrigeración;<br>
• producción de agua caliente sanitaria;<br>
• presencia de energías renovables, como paneles solares.

<strong>Recomendaciones de mejora</strong><br><br>

Además de la nota, el certificado incluye recomendaciones concretas para mejorar la eficiencia energética del inmueble, por ejemplo:
<br>• mejorar el aislamiento en tejado, fachada o suelo;<br>
• sustituir ventanas de vidrio simple por doble o triple;<br>
• instalar paneles solares o una bomba de calor.

Estas mejoras pueden reducir el consumo, aumentar el confort y mejorar el valor del inmueble.

<strong>Del consumo energético a la sostenibilidad</strong><br><br>

El certificado muestra cómo gestiona su vivienda la energía y cómo de preparada está para un futuro sostenible.  
Un inmueble bien aislado, con calefacción eléctrica eficiente o bomba de calor, obtiene normalmente una mejor calificación.

<strong>¿Quién emite el certificado?</strong><br><br>

El certificado energético es elaborado por un técnico certificador autorizado.  
Este profesional realiza una inspección detallada y registra más de 150 características del edificio en el software oficial (CE3X, HULC…).

Tras el análisis, registra el certificado en el organismo autonómico competente.

Un certificado registrado tiene una validez de 10 años.

¿Quiere saber si su vivienda ya tiene un certificado vigente?  
En <strong>CEEcasasespaña.com</strong> le ayudamos a verificarlo y, si es necesario, solicitar uno nuevo.
</p>

                        </div>
                    </div>

                    <br>

                    <div class="max-w-4xl mx-auto prose prose-lg">
                        <div class="bg-white p-8 rounded-lg shadow-sm">

<h2 id="what-is-the-benefit-of-an-energy-label" class="text-2xl text-blue-900 mb-4">¿Qué beneficios tiene un certificado energético?</h2>

<p class="mb-4">
El certificado energético es obligatorio en la venta, alquiler o construcción de un inmueble, pero ¿qué ventajas ofrece realmente?  
Aquí resumimos los principales beneficios.

<strong>Conocer la eficiencia energética</strong><br><br>

Los compradores o inquilinos pueden saber de inmediato cuánta energía consume una vivienda.  
Un inmueble eficiente ofrece más confort, menores gastos mensuales y menos emisiones de CO₂.

Además, una buena calificación aumenta el valor de la vivienda.  
En España, los compradores están cada vez más dispuestos a pagar más por viviendas con una clasificación A, B o C, debido a sus menores costes energéticos.

<strong>Consejos de mejora</strong><br><br>

En el certificado aparecerán recomendaciones de mejora adaptadas al inmueble, por ejemplo:
<br>• dónde añadir aislamiento;<br>
• si la instalación de paneles solares es rentable;<br>
• si una bomba de calor puede ser una opción viable.

<strong>Ventajas en venta o alquiler</strong><br><br>

Las viviendas con clasificación alta se venden más rápido y a mejor precio.  
Los inquilinos también valoran cada vez más la eficiencia energética porque influye directamente en sus gastos mensuales.

<strong>Mejor financiación</strong><br><br>

Muchos bancos españoles ofrecen hipotecas verdes o préstamos con condiciones especiales para viviendas eficientes o reformas energéticas.  
El certificado energético oficial sirve como prueba para acceder a estas ventajas.

En resumen, el certificado energético es mucho más que una obligación legal: es una herramienta útil que aporta valor, ahorro y sostenibilidad.
</p>

                        </div>
                    </div>

                </main>

                <aside class="md:w-1/3 mt-6 md:mt-0">
                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <img src="/images/team/compare.webp" alt="Comparar técnicos certificadores" class="mb-4 w-full h-auto rounded-md object-cover" />
                        <p class="mb-4">Comience a comparar técnicos certificadores en España.</p>
                        <p><a href="/cadastro/" data-route="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Comparar técnicos</a></p>
                    </div>
                </aside>

            </div>
        </div>
    </section>
</div>

        `;
}